import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { Link } from 'react-router-dom';

dayjs.locale('es');

const EventResume = ({ event, handleSchedule }) => {

  const is_unique = event.is_unique ?? false;
  const is_edited = event.is_edited ?? false;
  const event_id = event.event_id;
  const start_date = event.start_date?.format('YYYY-MM-DD HH:mm:ss');
  const end_date = event.end_date?.format('YYYY-MM-DD HH:mm:ss');

  const query = new URLSearchParams({
    is_unique,
    is_edited,
    event_id,
    start_date,
    end_date,
  }).toString();

  return (
    <div
      className={`mx-auto text-center themed-block mb-3 p-5 border-type-${event.class_type_id}`}
      style={{ width: '350px' }}
      data-day={event.start_date.format('YYYY-MM-DD')}
      data-class-type={event.class_type_id}
    >
      <div>
        <div>
          <h3 className="d-block my-2">{event.name}</h3>
          <p className="d-block my-1">
            <span className="font-weight-bold">Día:</span> {event.start_date.tz(dayjs.tz.guess()).format('dddd D [de] MMMM')}
          </p>
          <p className="d-block my-1">
            <span className="font-weight-bold">Hora:</span> {event.start_date.tz(dayjs.tz.guess()).format('HH:mm')} - {event.end_date.tz(dayjs.tz.guess()).format('HH:mm')}
          </p>
          <p className="d-block my-1">
            <span className="font-weight-bold">Lugar:</span> {event.place}
          </p>
          <div className="d-block my-1">
            <span className="material-symbols-outlined align-middle">diversity_3</span>
            <p className="d-inline-block">
              {event.attendees?.length} / {event.quotas}
            </p>
          </div>
        </div>
        <div className="ml-auto my-3 d-flex justify-content-around">
          <button type="button" className="btn themed-btn mt-3 d-block" onClick={() => handleSchedule(event)}>Agendar</button>

          <Link
            to={`/events/${event_id}?${query}`}
            className="btn themed-btn mt-3"
          >
            Más Info
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventResume;
